import { render, staticRenderFns } from "./kpi-addstage.vue?vue&type=template&id=a9d859a6"
import script from "./kpi-addstage.vue?vue&type=script&lang=js"
export * from "./kpi-addstage.vue?vue&type=script&lang=js"
import style0 from "./kpi-addstage.vue?vue&type=style&index=0&id=a9d859a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports